import { Tabs, TabsContent, TabsList, TabsTrigger } from "alm-react-components";
import parse from "html-react-parser";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { TabConstants } from "../../../assets/constants/constants";
import getLocalizedContent from "../../../lib/getLocalizedMetaData";

interface TabSectionProps {
  courseResponse: any;
  courseId: string;
}

export const VideoTutorialDetailsTab: React.FC<TabSectionProps> = ({
  courseResponse,
  courseId,
}) => {
  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = useState(TabConstants.defaultTab);
  const setTabAction = (action: string) => {
    if (tabIndex !== action) setTabIndex(action);
  };
  useEffect(() => {
    setTabIndex(TabConstants.defaultTab);
  }, [courseId]);
  return (
    <>
      <section className="">
        <div className="">
          <div className="mr-auto w-full">
            <div className="mt-1 text-sm leading-6 md:mt-0">
              <Tabs
                defaultValue="overview"
                value={tabIndex}
                className="w-full bg-transparent"
              >
                <TabsList className="w-full bg-transparent items-start justify-start rounded-none h-auto p-0 border border-x-0 px-4 xl:px-32 md:px-8 lg:px-8">
                  <TabsTrigger
                    value="overview"
                    className={`pb-5 pt-5 text-lg h-auto rounded-none mx-4 ml-0 md:mx-[20px] md:ml-[0px] px-0 ${
                      tabIndex === TabConstants.defaultTab
                        ? "border-b-[4px] dark:border-primary dark:text-primary active:dark:border-primary"
                        : ""
                    }`}
                    onClick={() => setTabAction(TabConstants.defaultTab)}
                  >
                    <span
                      dangerouslySetInnerHTML={{ __html: t("Common.overview") }}
                    />
                  </TabsTrigger>
                </TabsList>
                <TabsContent
                  value="overview"
                  className="w-full py-14 px-4 xl:px-32 md:px-8 lg:px-8"
                >
                  {tabIndex === TabConstants.defaultTab && (
                    <>
                      <div className="">
                        <h2 className="text-4xl font-barlowLight text-left pb-6"></h2>
                        <div className="text-base font-normal font-sans pb-4  ql-editor">
                          {courseResponse &&
                            parse(
                              getLocalizedContent(
                                courseResponse?.attributes?.localizedMetadata
                              )?.richTextOverview
                            )}
                        </div>
                      </div>
                    </>
                  )}
                </TabsContent>
              </Tabs>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
